import { render, staticRenderFns } from "./TouchReservationAttendance.vue?vue&type=template&id=bdc23280&scoped=true&"
import script from "./TouchReservationAttendance.vue?vue&type=script&lang=js&"
export * from "./TouchReservationAttendance.vue?vue&type=script&lang=js&"
import style0 from "./TouchReservationAttendance.vue?vue&type=style&index=0&id=bdc23280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc23280",
  null
  
)

export default component.exports